/* ISAMOR · Cart delivery property privacy
   Oculta únicamente propiedades técnicas de entrega en /cart y cart drawer.
   P2: dirigido por eventos nativos de Shopify; sin MutationObserver global. */

import { StandardEvents } from '@shopify/events';

const DELIVERY_LABELS = [
  'entrega estimada',
  'fecha estimada de entrega',
  'estimated between',
  'estimated delivery',
  'delivery estimate',
];

const normalize = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/:\s*$/, '')
    .trim();

const normalizedLabels = DELIVERY_LABELS.map(normalize);

const isDeliveryProperty = (label = '') => {
  const normalized = normalize(label);
  return normalizedLabels.some((candidate) => normalized === candidate || normalized.includes(candidate));
};

function hideDeliveryProperties(scope = document) {
  const lists = scope.querySelectorAll?.('.cart-items__properties') || [];

  lists.forEach((list) => {
    const rows = [...list.querySelectorAll('.cart-items__property')];
    let visibleRows = 0;

    rows.forEach((row) => {
      const label = row.querySelector('dt')?.textContent || '';
      const deliveryProperty = isDeliveryProperty(label);

      row.hidden = deliveryProperty;
      row.toggleAttribute('aria-hidden', deliveryProperty);

      if (deliveryProperty) {
        row.style.setProperty('display', 'none', 'important');
      } else {
        row.style.removeProperty('display');
        visibleRows += 1;
      }
    });

    const hideList = rows.length > 0 && visibleRows === 0;
    list.hidden = hideList;
    list.toggleAttribute('aria-hidden', hideList);
    if (hideList) list.style.setProperty('display', 'none', 'important');
    else list.style.removeProperty('display');
  });
}

let scheduled = false;
function schedulePolish() {
  if (scheduled) return;
  scheduled = true;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scheduled = false;
      hideDeliveryProperties(document);
    });
  });
}

function handleCartLinesUpdate(event) {
  if (event?.promise && typeof event.promise.then === 'function') {
    event.promise.then(schedulePolish).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[isamor-cart-property-polish] Cart update rejected:', error);
    });
  } else {
    schedulePolish();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', schedulePolish, { once: true });
} else {
  schedulePolish();
}

document.addEventListener(StandardEvents.cartLinesUpdate, handleCartLinesUpdate);
window.addEventListener('pageshow', schedulePolish);
